import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@folio/stripes-components';
import NavButton from '../../MainNav/NavButton';

function HelpeButton({ helpUrl, setIsFullScreen }) {
  return (
    <NavButton
      aria-label="Help button"
      data-test-item-help-button
      href={helpUrl}
      icon={<Icon icon="question-mark" />}
      id="helpButton"
      target="_blank"
      onMouseDown={(e) => {
        e.preventDefault();
        setIsFullScreen(false);
      }}
    />
  );
}

HelpeButton.propTypes = {
  helpUrl: PropTypes.string,
  setIsFullScreen: PropTypes.func,
};

export default HelpeButton;
